import React from 'react';
import { MailIcon, Disc3Icon, Wrench as WrenchIcon } from 'lucide-react';
import { Reveal } from '../Reveal';
import { SectionHeading } from '../SectionHeading';

/* CONTACT — replaced the Newsletter section (Ryan, Aug 29).
   Two lanes: Event Production → info@futureastronautco.com,
   Record Label → ryan@futureastronautco.com.
   Newsletter.tsx stays in the repo (archived) — re-import + mount to bring it back. */

const CONTACTS = [{
  icon: WrenchIcon,
  eyebrow: 'EVENT PRODUCTION',
  blurb: 'Stages, lighting, sound, LED and show production for festivals and venues.',
  email: 'info@futureastronautco.com',
  accent: 'cyan' as const
}, {
  icon: Disc3Icon,
  eyebrow: 'RECORD LABEL',
  blurb: 'Future Astronaut Records — releases, licensing, press and partnerships.',
  email: 'ryan@futureastronautco.com',
  accent: 'violet' as const
}];
export function Contact() {
  return <section id="contact" className="relative mx-auto w-full max-w-7xl px-5 py-20 sm:px-8 sm:py-24" data-id="element-101" data-mp="2yamlma98p9ld">
      <SectionHeading align="center" eyebrow="GET IN TOUCH" title={<>
            Contact <span className="text-gradient" data-id="element-103" data-mp="2693nhz2b8s3w">mission control</span>
          </>} description="Booking a show, building a stage, or bringing us a record — pick your lane." data-id="element-102" data-mp="2b75er79w3xqg" />

      <div className="mx-auto mt-12 grid w-full max-w-3xl gap-5 sm:grid-cols-2" data-id="element-104" data-mp="2fzor60wucmto">
        {CONTACTS.map((c, i) => {
        const Icon = c.icon;
        const cyan = c.accent === 'cyan';
        return <Reveal key={c.email} delay={i * 0.08} data-id="element-105" data-mp="1nclznsql1ccx" data-mpi={i}>
              <a href={`mailto:${c.email}`} className={`glass group flex h-full flex-col items-center rounded-3xl px-6 py-9 text-center transition-[transform,border-color,box-shadow] duration-300 ease-expo hover:-translate-y-1 ${cyan ? 'hover:border-cyan/50 hover:shadow-neon-cyan' : 'hover:border-violet/50 hover:shadow-neon'}`} data-id="element-106" data-mp="2281va26t9gbf">
                <span className={`flex h-12 w-12 items-center justify-center rounded-2xl border ${cyan ? 'border-cyan/40 bg-cyan/10 text-cyan' : 'border-violet/40 bg-violet/10 text-violet-soft'}`} data-id="element-107" data-mp="3fteqjolh0ab0">
                  <Icon className="h-5 w-5" aria-hidden="true" data-id="element-108" data-mp="2x0szdhlid7wr" />
                </span>
                <p className={`mt-5 font-tech text-[0.68rem] font-semibold tracking-[0.28em] ${cyan ? 'text-cyan/85' : 'text-violet-soft'}`} data-id="element-109" data-mp="31zngmf3tuoer">
                  {c.eyebrow}
                </p>
                <p className="mt-3 text-sm leading-relaxed text-white/55" data-id="element-110" data-mp="3br0bzgou3wpj">{c.blurb}</p>
                <span className="mt-5 inline-flex items-center gap-2 font-tech text-sm font-medium tracking-[0.04em] text-white underline-offset-4 transition-colors duration-200 ease-out group-hover:underline" data-id="element-111" data-mp="2e99z3iivc7yf">
                  <MailIcon className="h-4 w-4 opacity-60" aria-hidden="true" data-id="element-112" data-mp="10di489ezbh94" />
                  {c.email}
                </span>
              </a>
            </Reveal>;
      })}
      </div>
    </section>;
}